import { useEffect } from 'react';
import buildGTM from 'react-google-tag-manager';

import config from 'config';

export const useGoogleTagManager = props => {
  const gtm = buildGTM({
    id: props.gtmId,
    additionalEvents: props.additionalEvents,
    dataLayerName: props.dataLayerName,
  });

  useEffect(() => {
    if (!document.querySelector(`script[src='//www.googletagmanager.com/gtm.js?id=${props.gtmId}']`)) {
      const script = document.createElement('script');
      script.setAttribute('defer', '');
      script.innerHTML = gtm.scriptAsHTML().replace(/<\/?script>/g, '');
      if (document.body) {
        document.body.appendChild(script);
      }
    }
  }, [gtm, props.gtmId]);
};

const pageData = props => {
  const { type, channel, destinationURL, referringURL } = props;
  const country = props.country || 'CA';

  return {
    pageInfo: {
      destinationURL: destinationURL || window.location.href,
      domain: `UNI_${country}`,
      platform: 'host',
      publisher: 'universe',
      publisherDivision: country,
      environment: config.environment,
      Experience: '',
      pageChannel: channel,
      pageType: type,
      pageName: `UNI_${country}: ${type}`,
      referringURL: referringURL || localStorage.getItem('referringURL'),
    },
  };
};

export const setDigitalData = props => {
  try {
    const digitalData = {
      page: pageData(props),
      cart: {},
      transaction: {},
    };

    window.digitalData = digitalData;
  } catch (e) {
    console.log('Error', e); // eslint-disable-line no-console
  }
};

export const DefaultDigitalData = () => {
  setDigitalData({
    type: 'Host Page',
    channel: 'host_page',
    country: 'CA',
  });

  useGoogleTagManager({ gtmId: config.gtm });
  return null;
};

export const googleTagManagerEvent = event => {
  if (window.dataLayer && window.dataLayer.push instanceof Function) {
    window.dataLayer.push(event);
  }
};

export const updatePageTrackDigitalData = currentURL => {
  if (localStorage.getItem('currentURL') !== currentURL) {
    localStorage.setItem('referringURL', localStorage.getItem('currentURL'));
    localStorage.setItem('currentURL', currentURL);
    setDigitalData({destinationURL: currentURL, referringURL: localStorage.getItem('referringURL')});
  }
}
